module.exports = __webpack_public_path__ + "static/patio-7e1b47da0ce7cc608a2a9f8b2d862e8c.jpg";